import { useEffect, useState } from 'react';
import { get } from '../api';
import DataTable from '../components/data-table/data-table';
import { Link } from 'react-router-dom';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    get('users')
      .then(setUsers)
      .catch(() => {});
  }, []);

  return (
    <div>
      <DataTable
        data={users}
        columns={[
          {
            name: 'id',
            label: 'ID',
          },
          {
            name: 'username',
            label: 'Username',
          },
          // {
          //     name: 'email',
          //     label: 'Email'
          // },
          {
            name: '',
            label: '',
            render: ({ row }: any) => (
              <Link to={`/users/${row.id}`} className="button">
                Go
              </Link>
            ),
          },
        ]}
      />
    </div>
  );
}
